// Auto apply discount code
(function() {
  // Function to get the appropriate discount code based on customer type
  function getDiscountCode() {
    console.log('Checking customer login status...');
    // Check if customer is logged in using data attribute
    const isCustomerLoggedIn = document.body.getAttribute('data-customer-logged-in') === 'true';
    
    if (isCustomerLoggedIn) {
      console.log('Customer is logged in, applying VET discount');
      return 'Free%2520US%2520Standard%2520Shipping%2520-%2520VET';
    }
    // Default discount code for non-logged in customers
    console.log('Customer is not logged in, applying standard discount');
    return 'Free%2520US%2520Standard%2520Shipping';
  }

  // Function to apply the discount code
  async function applyDiscount() {
    try {
      const discountCode = getDiscountCode();
      console.log('Attempting to apply discount code:', discountCode);
      const response = await fetch(`/discount/${discountCode}`);
      if (response.ok) {
        console.log('Discount applied successfully');
      } else {
        console.error('Failed to apply discount. Status:', response.status);
        console.error('Response:', await response.text());
      }
    } catch (error) {
      console.error('Error applying discount:', error);
    }
  }

  // Add click event listener to checkout button
  document.addEventListener('click', function(event) {
    // Check if the clicked element is the checkout button using multiple selectors
    if (event.target.matches('#checkout, button[name="checkout"], .air-btn--primary[name="checkout"], button[form="cart"][name="checkout"]')) {
      console.log('Checkout button clicked, applying discount');
      applyDiscount();
    }
  });

  // Also listen for form submission on the cart form
  const cartForm = document.getElementById('cart');
  if (cartForm) {
    cartForm.addEventListener('submit', function(event) {
      console.log('Cart form submitted, applying discount');
      applyDiscount();
    });
  }
})(); 